module.exports = __webpack_public_path__ + "static/media/selfies.7409d769.gif";